import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LenderConfiguration } from '@shared/model/lender-config.model';
import { SawDust } from '@cudirect/shared-ui-library';

/** @dynamic */
// https://github.com/angular/angular/issues/20351
@Injectable({
  providedIn: 'root'
})
export class LenderService {
  readonly logger = inject(SawDust);

  // TODO: We should try to set an enterprise standard model for Lender Meta data
  // Allow for different data models to be returned. Currently AS5 and Consumer Portal are using different LenderData models
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public lenderData: LenderConfiguration;

  constructor(private readonly http: HttpClient) {}
  /*
   * @url - string, A valid API endpoint
   * @bodyClass -  string, a class that will be removed after asyn is complete
   * @debug -  boolean, whether to console log api response
   *
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async getLenderData(url: string, headers: any = {}): Promise<void> {
    // tslint:disable-next-line: no-void-expression
    const asyncResponse = await this.http
      .get(url, { headers })
      .toPromise()
      .then((data) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.lenderData = data as any; // Allow for different data models to be returned
        this.logger.withContext({
          orgCode: this.lenderData.consumerLoanCode,
          lenderName: this.lenderData.lenderName
        });
      })
      .catch(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.lenderData = null as any;
      });

    return asyncResponse;
  }

  /**
   * Retrieve Lender Data
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get lenderDataInfo(): LenderConfiguration {
    return this.lenderData;
  }

  /** Set LenderData, for applications that have already defined it themselves
   *
   * @data the lender data to set
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public set lenderConfigData(data: any) {
    this.lenderData = data; // Allow for different data models to be returned
  }
}
